<div class="flex-container">
  <div class="container" *ngIf="!isTravelerSignup() && !isNewDependent()">
    <div class="f-row">
      <app-breadcrumbs></app-breadcrumbs>
    </div>
    <div class="f-row">
      <ng-container *ngIf="renderer">
        <router-outlet></router-outlet>
      </ng-container>
    </div>
  </div>
  <div *ngIf="isTravelerSignup()">
    <app-new-traveler-form></app-new-traveler-form>
  </div>
  <div *ngIf="isNewDependent()">
    <app-dependent-information-form></app-dependent-information-form>
  </div>
</div>